import { render, staticRenderFns } from "./StaticUploadModeNav.vue?vue&type=template&id=60dadf70&scoped=true&"
import script from "./StaticUploadModeNav.vue?vue&type=script&lang=js&"
export * from "./StaticUploadModeNav.vue?vue&type=script&lang=js&"
import style0 from "./StaticUploadModeNav.vue?vue&type=style&index=0&id=60dadf70&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60dadf70",
  null
  
)

export default component.exports